<template>
  <v-container fluid>
    <v-row>
      <h2>Vital Sign</h2>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="4" sm="4" md="4">
            <v-text-field
                outlined
                type="number"
                v-model="formData.physical_examination.vital_sign.systolic"
                :rules="[v => !!v || 'Systolic is required']"
                label="Systolic"
                required
            />
          </v-col>
          <v-col cols="4" sm="4" md="4">
            <v-text-field
                outlined
                type="number"
                v-model="formData.physical_examination.vital_sign.diastolic"
                :rules="[v => !!v || 'Diastolic is required']"
                label="Diastolic"
                required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p>
              <b>Note</b>: <i>Definite value required for Patient from age three years old and above. </i>
            </p>
            <p>
              <i>Use <b style="color: #ff0000">"1"</b> as value for systolic and diastolic for patients which BP are not
                available or not required and <b style="color: #ff0000">"2"</b> for Palpatory Patients</i>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            <v-text-field
                outlined
                type="number"
                v-model="formData.physical_examination.vital_sign.hr"
                :rules="[v => !!v || 'Heart Rate is required']"
                label="Heart Rate"
                required
                placeholder="beats / minute"
                hint="beats / minute"
                persistent-hint
            />
          </v-col>
          <v-col>
            <v-text-field
                outlined
                type="number"
                v-model="formData.physical_examination.vital_sign.rr"
                :rules="[v => !!v || 'Respiratory Rate is required']"
                label="Respiratory Rate"
                required
                placeholder="breaths / minute"
                hint="breaths / minute"
                persistent-hint
            />
          </v-col>
          <v-col>
            <v-text-field
                outlined
                type="number"
                v-model="formData.physical_examination.vital_sign.temp"
                :rules="[v => !!v || 'Temperature is required']"
                label="Temperature"
                required
                placeholder="° Celsius"
                hint="° Celsius"
                persistent-hint
            />
          </v-col>
        </v-row>
        <div v-if="formData.patient.admission_date >= date" class="mt-5">
          <v-row>
            <v-col cols="4">
              <v-text-field
                  outlined
                  type="number"
                  v-model="formData.physical_examination.vital_sign.height"
                  :rules="[
                    v => !!v || 'Height(cm) is required',
                    v => (v && v.length <= 6) || 'Max digit of 6',
                  ]"
                  label="Height(cm)"
                  required
                  :counter="6"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                  outlined
                  type="number"
                  v-model="formData.physical_examination.vital_sign.weight"
                  :rules="[
                    v => !!v || 'Weight(kg) is required',
                    v => (v && v.length <= 6) || 'Max digit of 6'
                  ]"
                  label="Weight(kg)"
                  required
                  :counter="6"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VitalSign",

  props: {
    formData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      date: '2021-03-01',
    }
  },

  methods: {
    async getDateAdmissionRequired() {
      return await axios.get(
          "config-admission-required-date",
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("AUTH_TOKEN"),
            },
          }
      );
    },

    async setDateAdmissionRequired() {
      const {data} = await this.getDateAdmissionRequired();
      this.date = data;
    }
  },

  async mounted() {
    await this.setDateAdmissionRequired();
  }
}
</script>

<style scoped>

</style>